module.exports = __webpack_public_path__ + "img/profile_two_title.eccff070.png";